// extracted by mini-css-extract-plugin
export var cancelButton = "_on-5";
export var content = "_on-3";
export var createButton = "_on-6";
export var drawerContainer = "_on-0";
export var footer = "_on-2";
export var header = "_on-1";
export var orderFormColumn = "_on-4";